import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39a61903"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }

import {computed} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import _ from "lodash";
import {NumberRangeFieldType} from "@/components/business/crud/interface/FieldType";
import NumberRangeTable from "@/components/business/crud/widgets/impl/NumberRangeTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberRangeForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const minValue = computed({
  get() {
    return data.value[props.widget.minPropName];
  },
  set(val?: number) {
    val = _.isFinite(val) ? val : undefined;
    if (val !== undefined && props.widget.type === 'string') {
      data.value[props.widget.minPropName] = val.toString();
    } else {
      data.value[props.widget.minPropName] = val;
    }
  }
})

const maxValue = computed({
  get() {
    return data.value[props.widget.maxPropName];
  },
  set(val?: number) {
    val = _.isFinite(val) ? val : undefined;
    if (val !== undefined && props.widget.type === 'string') {
      data.value[props.widget.maxPropName] = val.toString();
    } else {
      data.value[props.widget.maxPropName] = val;
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_a_input_number, {
        class: "min",
        value: minValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((minValue).value = $event)),
        disabled: _ctx.info.status === 'show',
        placeholder: "最小值",
        precision: _ctx.widget.scale
      }, null, 8, ["value", "disabled", "precision"]),
      _createTextVNode(" - "),
      _createVNode(_component_a_input_number, {
        class: "max",
        value: maxValue.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((maxValue).value = $event)),
        disabled: _ctx.info.status === 'show',
        placeholder: "最大值",
        precision: _ctx.widget.scale
      }, null, 8, ["value", "disabled", "precision"])
    ], 512), [
      [_vShow, _ctx.info.status !== 'show']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(NumberRangeTable, _mergeProps({ data: _unref(data) }, _ctx.$props), null, 16, ["data"])
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})